import { Configuration, NotificationsApi } from '@sr-sdks/api-sdk-axios';
import { useQuery } from '@tanstack/react-query';
import { configuration } from '../../configuration';
import axiosInstance, { bypassCacheConfig } from '../../utils/axiosInstance';
import { toApiError } from '../../utils/httpError';

const notificationsKeys = {
  all: ['notifications'] as const,
  unread: (params?: UnreadNotificationsQueryParams) =>
    [...notificationsKeys.all, 'unread', { ...params }] as const,
};

const getNotificationsApi = () => {
  return new NotificationsApi(
    new Configuration(),
    configuration.SHARED_API_BASE,
    axiosInstance,
  );
};

export interface UnreadNotificationsQueryParams {
  page?: number;
  pageSize?: number;
  userId?: string;
}

export const getUnreadNotifications = async (
  params?: UnreadNotificationsQueryParams,
) => {
  try {
    const response = await getNotificationsApi().notificationControllerFindAll(
      false,
      undefined,
      params?.userId,
      undefined,
      params?.page,
      params?.pageSize,
      'created:desc',
      bypassCacheConfig(),
    );

    return response.data;
  } catch (error) {
    // Do NOT capture Sentry exceptions here; QueryCache.onError already captures.
    throw toApiError(error, {
      endpoint: 'notificationControllerFindAll',
      params,
    });
  }
};

export const useUnreadNotifications = (
  params?: UnreadNotificationsQueryParams,
) => {
  return useQuery({
    enabled: !!params?.userId,
    queryFn: () => getUnreadNotifications(params),
    queryKey: notificationsKeys.unread(params),
  });
};
